





























import Vue from 'vue'

interface Data {
  term: string,
  showKeyboard: boolean,
  position: number
}

export default Vue.extend({
  props: {
    placeholder: String,
    showSubmit: Boolean
  },
  data (): Data {
    return {
      term: '', // updated by watch
      showKeyboard: false,
      position: 0
    }
  },
  methods: {
    toggleKeyboard (): void {
      this.showKeyboard = !this.showKeyboard
    },
    // Update cursor position on input
    updatePosition (e: Event): void {
      if (e.target) {
        this.position = (e.target as HTMLInputElement).selectionStart || 0
      }
    },
    insert (letter: string): void {
      this.term = this.term.slice(0, this.position) + letter + this.term.slice(this.position)
      this.position += letter.length
    }
  },
  watch: {
    '$route.query.s': {
      handler (): void {
        if (this.$route.name === 'lexemes') {
          this.term = this.$route.query.s as string || ''
        } else {
          this.term = ''
        }
      },
      immediate: true
    },
    term: {
      // inform parent that contents of input has changed
      handler (): void {
        this.$emit('update', this.term)
      }
    }
  }
})
